export default __webpack_public_path__ + "static/media/reports_icon.b4204183.svg";